<template>
  <div class="wrap">
    <div class="fixedwrap">
      <el-row style="padding: 0px 40px">
        <el-button @click="tabfun(0)" style="margin-right:18px;" :type="activeTab == 0 ? 'primary' : ''">全部</el-button>
        <el-button @click="tabfun(1)" style="margin-right:18px;" :type="activeTab == 1 ? 'primary' : ''">待处理</el-button>
        <el-button @click="tabfun(2)" style="margin-right:18px;" :type="activeTab == 2 ? 'primary' : ''">邀请面试</el-button>
        <el-button @click="tabfun(3)" style="margin-right:22px;" :type="activeTab == 3 ? 'primary' : ''">无意向</el-button>
      </el-row>

      <div class="filter">
        <el-select style="width: 180px;margin:10px 28px 10px 0px;" v-model="sourcevalue" multiple collapse-tags
          placeholder="简历来源">
          <el-option v-for="item in sourceList" :key="item.value" :label="item.label" :value="item.id">
          </el-option>
        </el-select>

        <el-select style="width: 120px;margin: 10px 28px 10px 0px;" multiple collapse-tags :placeholder="Agese">
          <el-option style="height:80px;padding-right: 20px;" disabled>
            <span>请输入年龄范围，不填写则为不限</span><br>
            <div style="display: flex;justify-content: center;">
              <span>
                <el-input style="width: 80px;" v-model="startAge" @blur="inputblur"></el-input>
              </span>&nbsp; —— &nbsp;
              <span>
                <el-input style="width: 80px;" v-model="endAge" @blur="inputblur"></el-input>
              </span>
            </div>
          </el-option>
        </el-select>

        <el-select style="width: 120px;margin: 10px 28px 10px 0px;" multiple collapse-tags :placeholder="workse">
          <el-option style="height:80px;padding-right: 20px;" disabled>
            <span>请输入工作年限范围，不填写则为不限</span><br>
            <div style="display: flex;justify-content: center;">
              <span>
                <el-input style="width: 80px;" v-model="startWork" @blur="Workblur"></el-input>
              </span>&nbsp; —— &nbsp;
              <span>
                <el-input style="width: 80px;" v-model="endWork" @blur="Workblur"></el-input>
              </span>
            </div>
          </el-option>
        </el-select>

        <el-select style="width: 150px;margin: 10px 28px 10px 0px;" v-model="activeEducation" multiple collapse-tags
          placeholder="学历">
          <el-option v-for="item in educationList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <el-select style="width: 80px;margin: 10px 28px 10px 0px;" v-model="activeSex" placeholder="性别">
          <el-option v-for="(item, index) in sexList" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <el-select style="width: 240px;margin: 10px 28px 10px 0px;" v-model="activeSkill" multiple collapse-tags
          placeholder="选择技能标签">
          <el-option v-for="item in skillList" :key="item.value" :label="item.skill" :value="item.id">
          </el-option>
        </el-select>

        <el-select style="width: 200px;margin: 10px 28px 10px 0px;" v-model="activeCertification" multiple collapse-tags
          placeholder="人才认证">
          <el-option v-for="item in certificationList" :key="item.value" :label="item.label" :value="item.id">
          </el-option>
        </el-select>

        <button class="reset" @click="restComponent">重置</button>
        <button class="sizer" @click="onRefresh">筛选</button>
      </div>
    </div>

    <div class="pagessc">
      <div class="wrap6s flex-col" v-for="(item, index) in datalist" :key="index" @click="godatas(item.userId,item.positionName,item.workYear,item.recordId,item.manageStatus)">
        <div class="bd2s flex-col">
          <div class="box6 flex-row">
            <span class="word12">{{ item.userName }}</span>
            <img class="img2" referrerpolicy="no-referrer"
              src="./assets/img/yihurencai.png"
              v-show="item.talentCertSw"
            />
            <div class="sub-title">
              <img src="./assets/img/delivery.png" alt="" slot="source" v-show="item.sourceType == 'user'" />
              <img src="./assets/img/ai.png" alt="" slot="source" v-show="item.sourceType == 'AI'" />
              <img src="./assets/img/talent.png" alt="" slot="source" v-show="item.sourceType == 'active'" />
            </div>
          </div>
          <div class="box7 flex-row justify-between">
            <span class="info5">{{ item.age }}岁</span>
            <span class="word13">{{ item.workYear }}年工作经验</span>
            <span class="txt6">{{ item.eduName }}</span>
            <span class="txt7">{{ item.schoolName }}</span>
          </div>
          <div class="box8 flex-col">
            <div class="section3 flex-row justify-between">
              <div class="skills-list">
                <div :class="i.certStatus ? 'renzheng item' : 'item'" v-for="(i, j) in item.userSkill" :key="j">
                  <img src="./assets/img/renzheng.png"
                    alt="" v-show="i.certStatus" />
                  {{ i.skill }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <el-pagination v-if="datalist.length !== 0" @current-change="handleCurrentChange" :current-page="page"
        layout="total, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        small
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
   <div class="nodata" v-if="datalist.length == 0">
          <img src="./assets/img/NoData2.png">
          <p>暂无候选人简历</p>
   </div>
  </div>
</template>
<script>
import qs from 'qs';
export default {
  data() {
    return {
      resumeData: {}, //个人简历
      sourcevalue: [],//选中的简历来源
      talentCertSw: false, //是否为壹护人才认证
      sourceList: [
        {
          label: "不限",
          id: 'null',
        },
        {
          label: "自投递",
          id: "user",
        },
        {
          label: "AI人才匹配",
          id: "AI",
        },
        {
          label: "人才库",
          id: "active",
        },
      ],//简历来源列表
      skillList: [], //技能列表
      activeCertification: [], //多选认证数组
      startAge: null, //年龄范围
      endAge: null, //年龄范围
      Agese: '年龄', //年龄范围
      workse: '经验', //经验范围
      startWork: null, //工作年限范围
      endWork: null, //工作年限范围
      activeSex: null, //选中性别
      activeEducation: [], //选中学历
      activeSkill: [], //多选技能数组

      certificationList: [
        {
          label: "壹护认证人才",
          id: 1,
        },
        {
          label: "技能官方认证",
          id: 2,
        },
      ], //认证数组
      sexList: [
        {
          label: "不限",
          value: 0,
        },
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ], //性别数组
      educationList: [
        {
          label: "高中",
          value: 1,
        },
        {
          label: "大专",
          value: 2,
        },
        {
          label: "本科",
          value: 3,
        },
        {
          label: "研究生",
          value: 4,
        },
        {
          label: "博士",
          value: 5,
        },
      ], //学历数组
      activeTab: 0,
      total: null,
      page: 1,
      pageSize: 10,
      datalist: [],//筛选后的数组
    }
  },
  created() {
    // this.getUsersList();
  },
  methods: {
    godatas(userId,positionName,workYear,recordId,manageStatus) {
      const { href } = this.$router.resolve({
        path: '/Candidateils',
        query: { userId:userId, positionName:positionName, workYear:workYear, recordId:recordId, manageStatus:manageStatus}
      });
      this.$store.state.stidx = 1;
      sessionStorage.setItem("store", this.$store.state.stidx);
      window.open(href, '_blank');
    },
    inputblur() {
      if (this.startAge != null && this.endAge != null) {
        this.Agese = this.startAge + '岁—' + this.endAge + '岁';
      }
    },
    Workblur() {
      if (this.startWork != null && this.endWork != null) {
        this.workse = this.startWork + '年 — ' + this.endWork + '年';

      }
    },
    tabfun(val) {
      this.activeTab = val;
      this.onRefresh();
    },
    // 重置筛选
    restComponent() {
      this.active = 0;
      this.activeSource = [];
      this.sourcevalue = [];
      this.startAge = null; //年龄范围
      this.endAge = null; //年龄范围
      this.Agese = "年龄"; //年龄范围
      this.startWork = null; //工作年限范围
      this.endWork = null; //工作年限范围
      this.workse = "经验"; //工作年限范围
      this.activeSex = null; //选中性别
      this.activeEducation = []; //选中学历
      this.activeSkill = []; //多选技能数组
      this.activeCertification = []; //多选认证数组
      this.onRefresh();
    },
    onRefresh() {
      let parmes = {
        companyId: localStorage.getItem("id"),
        sex: this.activeSex ? this.activeSex : 0,
        manageStatus: this.activeTab,
        page: this.page,
        pageSize: this.pageSize,
      };

      if (this.startAge !== null && this.endAge !== null) {
        parmes.startAge = this.startAge;
        parmes.endAge = this.endAge;
      }
      if (this.startWork !== null && this.endWork !== null) {
        parmes.workStart = this.startWork;
        parmes.workEnd = this.endWork;
      }

      if (this.activeEducation.length !== 0) {
        let arry = [];
        this.activeEducation.map((item) => {
          arry.push(item);
        });
        parmes.edu = arry.join(",");
      }
      if (this.sourcevalue.length !== 0) {
        let arry = [];
        this.sourcevalue.map((item) => {
          arry.push(item);
        });
        parmes.sourceType = arry.join(",");
      } else {
        parmes.sourceType = "";
      }

      if (this.activeCertification.length !== 0) {
        let arry = [];
        this.activeCertification.map((item) => {
          arry.push(item);
        });
        parmes.personnel = arry.join(",");
      }
      if (this.activeSkill.length !== 0) {
        let arry = [];
        this.activeSkill.map((item) => {
          arry.push(item);
        });
        parmes.skill = arry.join(",");
      }

      this.$apiFun.candidateManagement(qs.stringify(parmes)).then((data) => {
        if (data.code === 200) {
          this.datalist = data.data.list;
          this.total = data.data.total;
          this.loading.close();
        }
      })
    },
    // 分页
    //监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      this.page = newPage;
      this.onRefresh();
    }
  },
  mounted() {
    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.onRefresh();
    this.$apiFun.skillAll().then((data) => {
      if (data.code === 200) {
        this.skillList = data.data;
      }
    })
  }
}
</script>



<style scoped lang="less" src="./assets/index.less" />
<style lang="less" scoped>
.wrap {
  height: 91vh;
  overflow: auto;
  border: none;
  border-bottom: none;

  .fixedwrap {
    width: 100%;
    height: auto;
    background: #ffff;
    position: fixed;
    z-index: 99;
    padding-top: 10px;
  }
}

.nodata {
  text-align: center;
  margin: 25% auto;
}

.nodata img {
  width: 266px;
  height: 154px;
}

.nodata p {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 16px;
  text-align: center;
  padding-top: 14px;
}

.ah-pageing {
  text-align: left;
}
</style>